import { INITIAL_STRINGIFIED_QUERY_BUILDER_VALUE } from '@palette/constants/queryBuilder';

export const EMPTY_DEFAULT_VALUE = 'default';

export const FILTER_OBJECT_EMPTY_DEFAULT_VALUE = INITIAL_STRINGIFIED_QUERY_BUILDER_VALUE;
